export default function patternClosure(patterns, c, w, h, w0) {
    return class pathPattern {
        constructor(path, basePattern, sparkColor, next, stepFactor) {
            this.basePattern = basePattern; 
            this.sparkColor = sparkColor; 
            this.next = next; 
            this.spark = 0; 
            //stepFactor controls the speed of the spark by determining how many segments to break the path into
            this.sparkPath = createSparkPath(path, w, h, w0, stepFactor); 
            this.active = false; 
            this.display = basePattern; 
        }

        start() {
            this.active = true; 
        }

        update() {
            let { spark, basePattern, sparkColor, sparkPath, next } = this; 
            
            
            if (spark >= sparkPath.length) {
                this.active = false; 
                this.spark = 0; 
                this.display = basePattern; 
                //next = 0 evaluated as falsy
                // (next !== null) && patterns[next].start()
                if (next !== null) {
                    return {path: next}
                }
            }
            else {
                let [x, y, branch, branchIndex] = sparkPath[spark]
                //activating a new spark if indicated
                branch && patterns[branchIndex].start()
                this.display = c.createRadialGradient(x, y, 0, x, y, 50)
                this.spark += 1;
                this.display.addColorStop(0, sparkColor); 
                this.display.addColorStop(0.7, basePattern); 
            }
        }
    }
}

function createSparkPath(path, w, h, w0, stepFactor) {
    let sparkPath = [];
    //can increase or decrease the speed by changing the step size 
    let step = stepFactor * w0;
    // let step = .0012 * w0; 
    for (let i = 0; i < path.length - 1; i++) {
        let x1 = w[path[i][0]], x2 = w[path[i + 1][0]];
        let y1 = h[path[i][1]], y2 = h[path[i + 1][1]];
        let deltaX = x2 - x1;
        let deltaY = y2 - y1;
        let distance = Math.hypot(deltaX, deltaY);
        //Theta calculation turned out not to be needed, but left it here because damnit, it was hard. 
        //figure out angle for conic gradient using dot product, A dot B = |A||B|cos(theta)
        //conic gradient measures angles as clockwise from 12 oclock so A = <0, 1>
        //remember sign of Y has to be flipped (moving up vertically is decreasing in canvas coordinates)
        // A dot B = -deltaY
        // |A||B| = 1 * distance
        //theta = Math.acos(-1 * deltaY/distance)
        // let theta = Math.acos(-1 * deltaY/distance)
        // If deltaX < 0, Acos measures angle < Pi radians, which is from counterclockwise. So to get desired theta, take that 2*Pi - that result
        // if (deltaX < 0) theta = 2*Math.PI - theta; 
        let steps = Math.floor(distance / step);
        let dx = deltaX / steps, dy = deltaY / steps;
        //handle branch point triggers for sparks
        path[i][2] ? sparkPath.push([x1, y1, true, path[i][3]]) : sparkPath.push([x1, y1])
        for (let j = 1; j < steps; j++) {
            sparkPath.push([x1 + (dx * j), y1 + (dy * j), /*theta*/])
        }
    }
    return sparkPath;
}